import type { FC, ReactNode } from 'react';

import ProjectHeader from '../ProjectHeader';
import { Container, ProjectBody } from './styles';

type ProjectLayoutProps = {
    activeItem: string;
    sticky?: boolean;
    children: ReactNode;
};

const ProjectLayout: FC<ProjectLayoutProps> = ({ activeItem, sticky = false, children }) => (
    <Container>
        <ProjectHeader activeItem={activeItem} sticky={sticky} />
        <ProjectBody>{children}</ProjectBody>
    </Container>
);

export default ProjectLayout;
